export default function Header({ nombre, color, clicked}: { nombre: any; color:any; clicked:any;}) {


return (

    <header className="topbar" aria-label="Barra superior Sudoku" >
        <button className="game-topbar__btn game-topbar__btn--back" aria-label="Volver"  onClick={clicked} >
          
          <img className="botonMenu" src="./iconos/menu_desplegable.png" />
        </button>

        <div className="divTitulo"><h1 className="tituloJuegos">{nombre}</h1></div>



        
      </header>

    )
    



   
  
}

//<svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true">
            //<path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          //</svg>